
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ai9bRYk6OD7f9_45f7NvlC_AcJZULTCnaJv03JYkz_kr0CIMeta } from "/Users/jdo/org/brx/deck/2025/pages/ai.vue?macro=true";
import { default as indexHYngzJUNYOeB9mPgfWKSw5vkB_45xBnm7CY0B8VJnwaEUMeta } from "/Users/jdo/org/brx/deck/2025/pages/index.vue?macro=true";
import { default as IDEtestAlE_8_hA_45NHTcnex4PczYdeCIxACwr3kyMEeUsVcNbwMeta } from "/Users/jdo/org/brx/deck/2025/pages/IDEtest.vue?macro=true";
import { default as pixel_45canvas_45demoNS0Y95rWFypkfHoPJrvPhqJgiVc5N0NJbBhkvN_45aWTYMeta } from "/Users/jdo/org/brx/deck/2025/pages/pixel-canvas-demo.vue?macro=true";
import { default as golden_45spiral_45demoJGsDimSoJpMPZCxzk9oUBybyb9kd_45n2rt2M_45TD8dpWQMeta } from "/Users/jdo/org/brx/deck/2025/pages/golden-spiral-demo.vue?macro=true";
import { default as image_45comparison_45demongjftCsRLVVqYIsA9XUTwplj2iRrZt3E97FCz8BlHicMeta } from "/Users/jdo/org/brx/deck/2025/pages/image-comparison-demo.vue?macro=true";
export default [
  {
    name: "ai",
    path: "/ai",
    component: () => import("/Users/jdo/org/brx/deck/2025/pages/ai.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/jdo/org/brx/deck/2025/pages/index.vue")
  },
  {
    name: "IDEtest",
    path: "/IDEtest",
    component: () => import("/Users/jdo/org/brx/deck/2025/pages/IDEtest.vue")
  },
  {
    name: "pixel-canvas-demo",
    path: "/pixel-canvas-demo",
    component: () => import("/Users/jdo/org/brx/deck/2025/pages/pixel-canvas-demo.vue")
  },
  {
    name: "golden-spiral-demo",
    path: "/golden-spiral-demo",
    component: () => import("/Users/jdo/org/brx/deck/2025/pages/golden-spiral-demo.vue")
  },
  {
    name: "image-comparison-demo",
    path: "/image-comparison-demo",
    component: () => import("/Users/jdo/org/brx/deck/2025/pages/image-comparison-demo.vue")
  }
]